var parent = require('../../stable/object/create');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/object/create.js
// module id = 467
// module chunks = 0 1